app.siteSearch = {
    settings: {
        
    },

    init: function () {
        
    }
};